"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const routeContainers_1 = require("../../../comps/routeContainers");
const Nav_1 = require("./Nav");
const WorkflowRuns_1 = require("./WorkflowRuns");
const WorkflowSettings_1 = require("./WorkflowSettings");
class Routes extends react_1.default.Component {
    render() {
        const { workflow } = this.props;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(routeContainers_1.OsmosysRoute, { title: "Settings - Workflow", exact: true, path: "/workflows/:id/settings", component: WorkflowSettings_1.WorkflowSettings, componentProps: {
                    workflow,
                }, nav: Nav_1.Nav, navProps: {
                    activeTab: 'settings',
                    workflow,
                } }),
            react_1.default.createElement(routeContainers_1.OsmosysRoute, { title: "Workflow runs - Workflow", exact: true, path: "/workflows/:id/runs", component: WorkflowRuns_1.WorkflowRuns, componentProps: {
                    workflow,
                }, nav: Nav_1.Nav, navProps: {
                    activeTab: 'runs',
                    workflow,
                } })));
    }
}
exports.Routes = Routes;
//# sourceMappingURL=Routes.js.map